// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file crm/v1/contact.proto (package crm.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_struct, file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Base, ID } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file crm/v1/contact.proto.
 */
export const file_crm_v1_contact: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_google_protobuf_struct, file_types]);

/**
 * Contact message definition
 *
 * @generated from message crm.v1.Contact
 */
export type Contact = Message<"crm.v1.Contact"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID account_id = 2;
   */
  accountId?: ID;

  /**
   * @generated from field: types.ID address_id = 3;
   */
  addressId?: ID;

  /**
   * @generated from field: types.ID user_id = 4;
   */
  userId?: ID;

  /**
   * @generated from field: types.ID owner_user_id = 5;
   */
  ownerUserId?: ID;

  /**
   * @generated from field: string prefix = 6;
   */
  prefix: string;

  /**
   * @generated from field: string full_name = 7;
   */
  fullName: string;

  /**
   * @generated from field: string address_as = 8;
   */
  addressAs: string;

  /**
   * @generated from field: string email = 9;
   */
  email: string;

  /**
   * @generated from field: string phone = 10;
   */
  phone: string;

  /**
   * @generated from field: string role = 11;
   */
  role: string;

  /**
   * @generated from field: string department = 12;
   */
  department: string;

  /**
   * @generated from field: bool is_primary = 13;
   */
  isPrimary: boolean;

  /**
   * @generated from field: string notes = 14;
   */
  notes: string;

  /**
   * @generated from field: map<string, google.protobuf.Value> custom_attributes = 15;
   */
  customAttributes: { [key: string]: Value };

  /**
   * @generated from field: types.Base base = 16;
   */
  base?: Base;
};

/**
 * Describes the message crm.v1.Contact.
 * Use `create(ContactSchema)` to create a new message.
 */
export const ContactSchema: GenMessage<Contact> = /*@__PURE__*/
  messageDesc(file_crm_v1_contact, 0);

/**
 * Request/Response messages for Contact queries
 *
 * @generated from message crm.v1.GetContactRequest
 */
export type GetContactRequest = Message<"crm.v1.GetContactRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message crm.v1.GetContactRequest.
 * Use `create(GetContactRequestSchema)` to create a new message.
 */
export const GetContactRequestSchema: GenMessage<GetContactRequest> = /*@__PURE__*/
  messageDesc(file_crm_v1_contact, 1);

/**
 * @generated from message crm.v1.GetContactResponse
 */
export type GetContactResponse = Message<"crm.v1.GetContactResponse"> & {
  /**
   * @generated from field: crm.v1.Contact contact = 1;
   */
  contact?: Contact;
};

/**
 * Describes the message crm.v1.GetContactResponse.
 * Use `create(GetContactResponseSchema)` to create a new message.
 */
export const GetContactResponseSchema: GenMessage<GetContactResponse> = /*@__PURE__*/
  messageDesc(file_crm_v1_contact, 2);

/**
 * @generated from message crm.v1.ListContactsRequest
 */
export type ListContactsRequest = Message<"crm.v1.ListContactsRequest"> & {
  /**
   * @generated from field: crm.v1.ListContactsFilter filter = 1;
   */
  filter?: ListContactsFilter;

  /**
   * @generated from field: repeated crm.v1.ContactSortOption sorting = 2;
   */
  sorting: ContactSortOption[];

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message crm.v1.ListContactsRequest.
 * Use `create(ListContactsRequestSchema)` to create a new message.
 */
export const ListContactsRequestSchema: GenMessage<ListContactsRequest> = /*@__PURE__*/
  messageDesc(file_crm_v1_contact, 3);

/**
 * @generated from message crm.v1.ListContactsFilter
 */
export type ListContactsFilter = Message<"crm.v1.ListContactsFilter"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: google.protobuf.StringValue account_id = 2;
   */
  accountId?: string;

  /**
   * @generated from field: google.protobuf.StringValue address_id = 3;
   */
  addressId?: string;

  /**
   * @generated from field: google.protobuf.StringValue user_id = 4;
   */
  userId?: string;

  /**
   * @generated from field: google.protobuf.StringValue owner_user_id = 5;
   */
  ownerUserId?: string;

  /**
   * @generated from field: google.protobuf.StringValue prefix = 6;
   */
  prefix?: string;

  /**
   * @generated from field: google.protobuf.StringValue full_name = 7;
   */
  fullName?: string;

  /**
   * @generated from field: google.protobuf.StringValue address_as = 8;
   */
  addressAs?: string;

  /**
   * @generated from field: google.protobuf.StringValue email = 9;
   */
  email?: string;

  /**
   * @generated from field: google.protobuf.StringValue phone = 10;
   */
  phone?: string;

  /**
   * @generated from field: google.protobuf.StringValue role = 11;
   */
  role?: string;

  /**
   * @generated from field: google.protobuf.StringValue department = 12;
   */
  department?: string;

  /**
   * @generated from field: google.protobuf.StringValue notes = 14;
   */
  notes?: string;

  /**
   * @generated from field: google.protobuf.StringValue search_term = 16;
   */
  searchTerm?: string;

  /**
   * @generated from field: types.ID organization_id = 17;
   */
  organizationId?: ID;

  /**
   * @generated from field: repeated string roles = 15;
   */
  roles: string[];
};

/**
 * Describes the message crm.v1.ListContactsFilter.
 * Use `create(ListContactsFilterSchema)` to create a new message.
 */
export const ListContactsFilterSchema: GenMessage<ListContactsFilter> = /*@__PURE__*/
  messageDesc(file_crm_v1_contact, 4);

/**
 * @generated from message crm.v1.ListContactsResponse
 */
export type ListContactsResponse = Message<"crm.v1.ListContactsResponse"> & {
  /**
   * @generated from field: repeated crm.v1.Contact contacts = 1;
   */
  contacts: Contact[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message crm.v1.ListContactsResponse.
 * Use `create(ListContactsResponseSchema)` to create a new message.
 */
export const ListContactsResponseSchema: GenMessage<ListContactsResponse> = /*@__PURE__*/
  messageDesc(file_crm_v1_contact, 5);

/**
 * Command messages
 *
 * @generated from message crm.v1.CreateContactRequest
 */
export type CreateContactRequest = Message<"crm.v1.CreateContactRequest"> & {
  /**
   * @generated from field: crm.v1.ContactInput input = 1;
   */
  input?: ContactInput;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message crm.v1.CreateContactRequest.
 * Use `create(CreateContactRequestSchema)` to create a new message.
 */
export const CreateContactRequestSchema: GenMessage<CreateContactRequest> = /*@__PURE__*/
  messageDesc(file_crm_v1_contact, 6);

/**
 * @generated from message crm.v1.CreateContactResponse
 */
export type CreateContactResponse = Message<"crm.v1.CreateContactResponse"> & {
  /**
   * @generated from field: crm.v1.Contact contact = 1;
   */
  contact?: Contact;
};

/**
 * Describes the message crm.v1.CreateContactResponse.
 * Use `create(CreateContactResponseSchema)` to create a new message.
 */
export const CreateContactResponseSchema: GenMessage<CreateContactResponse> = /*@__PURE__*/
  messageDesc(file_crm_v1_contact, 7);

/**
 * @generated from message crm.v1.UpdateContactRequest
 */
export type UpdateContactRequest = Message<"crm.v1.UpdateContactRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: crm.v1.ContactUpdateInput input = 2;
   */
  input?: ContactUpdateInput;

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message crm.v1.UpdateContactRequest.
 * Use `create(UpdateContactRequestSchema)` to create a new message.
 */
export const UpdateContactRequestSchema: GenMessage<UpdateContactRequest> = /*@__PURE__*/
  messageDesc(file_crm_v1_contact, 8);

/**
 * @generated from message crm.v1.UpdateContactResponse
 */
export type UpdateContactResponse = Message<"crm.v1.UpdateContactResponse"> & {
  /**
   * @generated from field: crm.v1.Contact contact = 1;
   */
  contact?: Contact;
};

/**
 * Describes the message crm.v1.UpdateContactResponse.
 * Use `create(UpdateContactResponseSchema)` to create a new message.
 */
export const UpdateContactResponseSchema: GenMessage<UpdateContactResponse> = /*@__PURE__*/
  messageDesc(file_crm_v1_contact, 9);

/**
 * @generated from message crm.v1.DeleteContactRequest
 */
export type DeleteContactRequest = Message<"crm.v1.DeleteContactRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message crm.v1.DeleteContactRequest.
 * Use `create(DeleteContactRequestSchema)` to create a new message.
 */
export const DeleteContactRequestSchema: GenMessage<DeleteContactRequest> = /*@__PURE__*/
  messageDesc(file_crm_v1_contact, 10);

/**
 * Input messages
 *
 * @generated from message crm.v1.ContactInput
 */
export type ContactInput = Message<"crm.v1.ContactInput"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID account_id = 2;
   */
  accountId?: ID;

  /**
   * @generated from field: types.ID address_id = 3;
   */
  addressId?: ID;

  /**
   * @generated from field: types.ID user_id = 4;
   */
  userId?: ID;

  /**
   * @generated from field: types.ID owner_user_id = 5;
   */
  ownerUserId?: ID;

  /**
   * @generated from field: string prefix = 6;
   */
  prefix: string;

  /**
   * @generated from field: string full_name = 7;
   */
  fullName: string;

  /**
   * @generated from field: string address_as = 8;
   */
  addressAs: string;

  /**
   * @generated from field: string email = 9;
   */
  email: string;

  /**
   * @generated from field: string phone = 10;
   */
  phone: string;

  /**
   * @generated from field: string role = 11;
   */
  role: string;

  /**
   * @generated from field: string department = 12;
   */
  department: string;

  /**
   * @generated from field: bool is_primary = 13;
   */
  isPrimary: boolean;

  /**
   * @generated from field: string notes = 14;
   */
  notes: string;

  /**
   * @generated from field: map<string, google.protobuf.Value> custom_attributes = 15;
   */
  customAttributes: { [key: string]: Value };
};

/**
 * Describes the message crm.v1.ContactInput.
 * Use `create(ContactInputSchema)` to create a new message.
 */
export const ContactInputSchema: GenMessage<ContactInput> = /*@__PURE__*/
  messageDesc(file_crm_v1_contact, 11);

/**
 * @generated from message crm.v1.ContactUpdateInput
 */
export type ContactUpdateInput = Message<"crm.v1.ContactUpdateInput"> & {
  /**
   * @generated from field: types.ID account_id = 1;
   */
  accountId?: ID;

  /**
   * @generated from field: types.ID address_id = 2;
   */
  addressId?: ID;

  /**
   * @generated from field: types.ID user_id = 3;
   */
  userId?: ID;

  /**
   * @generated from field: types.ID owner_user_id = 4;
   */
  ownerUserId?: ID;

  /**
   * @generated from field: google.protobuf.StringValue prefix = 5;
   */
  prefix?: string;

  /**
   * @generated from field: google.protobuf.StringValue full_name = 6;
   */
  fullName?: string;

  /**
   * @generated from field: google.protobuf.StringValue address_as = 7;
   */
  addressAs?: string;

  /**
   * @generated from field: google.protobuf.StringValue email = 8;
   */
  email?: string;

  /**
   * @generated from field: google.protobuf.StringValue phone = 9;
   */
  phone?: string;

  /**
   * @generated from field: google.protobuf.StringValue role = 10;
   */
  role?: string;

  /**
   * @generated from field: google.protobuf.StringValue department = 11;
   */
  department?: string;

  /**
   * @generated from field: google.protobuf.BoolValue is_primary = 12;
   */
  isPrimary?: boolean;

  /**
   * @generated from field: google.protobuf.StringValue notes = 13;
   */
  notes?: string;

  /**
   * @generated from field: google.protobuf.StringValue custom_attributes = 14;
   */
  customAttributes?: string;
};

/**
 * Describes the message crm.v1.ContactUpdateInput.
 * Use `create(ContactUpdateInputSchema)` to create a new message.
 */
export const ContactUpdateInputSchema: GenMessage<ContactUpdateInput> = /*@__PURE__*/
  messageDesc(file_crm_v1_contact, 12);

/**
 * GetContactsByCustomAttributeRequest - custom query request
 *
 * @generated from message crm.v1.GetContactsByCustomAttributeRequest
 */
export type GetContactsByCustomAttributeRequest = Message<"crm.v1.GetContactsByCustomAttributeRequest"> & {
  /**
   * @generated from field: string attribute_name = 1;
   */
  attributeName: string;

  /**
   * @generated from field: repeated string attribute_values = 2;
   */
  attributeValues: string[];

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message crm.v1.GetContactsByCustomAttributeRequest.
 * Use `create(GetContactsByCustomAttributeRequestSchema)` to create a new message.
 */
export const GetContactsByCustomAttributeRequestSchema: GenMessage<GetContactsByCustomAttributeRequest> = /*@__PURE__*/
  messageDesc(file_crm_v1_contact, 13);

/**
 * GetContactsByCustomAttributeResponse - custom query response
 *
 * @generated from message crm.v1.GetContactsByCustomAttributeResponse
 */
export type GetContactsByCustomAttributeResponse = Message<"crm.v1.GetContactsByCustomAttributeResponse"> & {
  /**
   * @generated from field: repeated crm.v1.Contact result = 1;
   */
  result: Contact[];
};

/**
 * Describes the message crm.v1.GetContactsByCustomAttributeResponse.
 * Use `create(GetContactsByCustomAttributeResponseSchema)` to create a new message.
 */
export const GetContactsByCustomAttributeResponseSchema: GenMessage<GetContactsByCustomAttributeResponse> = /*@__PURE__*/
  messageDesc(file_crm_v1_contact, 14);

/**
 * CheckContactSearchPermissionsRequest - custom query request
 *
 * @generated from message crm.v1.CheckContactSearchPermissionsRequest
 */
export type CheckContactSearchPermissionsRequest = Message<"crm.v1.CheckContactSearchPermissionsRequest"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message crm.v1.CheckContactSearchPermissionsRequest.
 * Use `create(CheckContactSearchPermissionsRequestSchema)` to create a new message.
 */
export const CheckContactSearchPermissionsRequestSchema: GenMessage<CheckContactSearchPermissionsRequest> = /*@__PURE__*/
  messageDesc(file_crm_v1_contact, 15);

/**
 * CheckContactSearchPermissionsResponse - custom query response
 *
 * @generated from message crm.v1.CheckContactSearchPermissionsResponse
 */
export type CheckContactSearchPermissionsResponse = Message<"crm.v1.CheckContactSearchPermissionsResponse"> & {
  /**
   * @generated from field: repeated string result = 1;
   */
  result: string[];
};

/**
 * Describes the message crm.v1.CheckContactSearchPermissionsResponse.
 * Use `create(CheckContactSearchPermissionsResponseSchema)` to create a new message.
 */
export const CheckContactSearchPermissionsResponseSchema: GenMessage<CheckContactSearchPermissionsResponse> = /*@__PURE__*/
  messageDesc(file_crm_v1_contact, 16);

/**
 * @generated from enum crm.v1.ContactSortOption
 */
export enum ContactSortOption {
  /**
   * @generated from enum value: CONTACT_SORT_OPTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONTACT_SORT_OPTION_FULL_NAME_ASC = 1;
   */
  FULL_NAME_ASC = 1,

  /**
   * @generated from enum value: CONTACT_SORT_OPTION_FULL_NAME_DESC = 2;
   */
  FULL_NAME_DESC = 2,

  /**
   * @generated from enum value: CONTACT_SORT_OPTION_ADDRESS_AS_ASC = 3;
   */
  ADDRESS_AS_ASC = 3,

  /**
   * @generated from enum value: CONTACT_SORT_OPTION_ADDRESS_AS_DESC = 4;
   */
  ADDRESS_AS_DESC = 4,

  /**
   * @generated from enum value: CONTACT_SORT_OPTION_EMAIL_ASC = 5;
   */
  EMAIL_ASC = 5,

  /**
   * @generated from enum value: CONTACT_SORT_OPTION_EMAIL_DESC = 6;
   */
  EMAIL_DESC = 6,

  /**
   * @generated from enum value: CONTACT_SORT_OPTION_ROLE_ASC = 7;
   */
  ROLE_ASC = 7,

  /**
   * @generated from enum value: CONTACT_SORT_OPTION_ROLE_DESC = 8;
   */
  ROLE_DESC = 8,

  /**
   * @generated from enum value: CONTACT_SORT_OPTION_IS_PRIMARY_ASC = 9;
   */
  IS_PRIMARY_ASC = 9,

  /**
   * @generated from enum value: CONTACT_SORT_OPTION_IS_PRIMARY_DESC = 10;
   */
  IS_PRIMARY_DESC = 10,

  /**
   * @generated from enum value: CONTACT_SORT_OPTION_CREATED_AT_ASC = 11;
   */
  CREATED_AT_ASC = 11,

  /**
   * @generated from enum value: CONTACT_SORT_OPTION_CREATED_AT_DESC = 12;
   */
  CREATED_AT_DESC = 12,

  /**
   * @generated from enum value: CONTACT_SORT_OPTION_UPDATED_AT_ASC = 13;
   */
  UPDATED_AT_ASC = 13,

  /**
   * @generated from enum value: CONTACT_SORT_OPTION_UPDATED_AT_DESC = 14;
   */
  UPDATED_AT_DESC = 14,
}

/**
 * Describes the enum crm.v1.ContactSortOption.
 */
export const ContactSortOptionSchema: GenEnum<ContactSortOption> = /*@__PURE__*/
  enumDesc(file_crm_v1_contact, 0);

/**
 * Services
 *
 * @generated from service crm.v1.ContactQueriesService
 */
export const ContactQueriesService: GenService<{
  /**
   * @generated from rpc crm.v1.ContactQueriesService.GetContact
   */
  getContact: {
    methodKind: "unary";
    input: typeof GetContactRequestSchema;
    output: typeof GetContactResponseSchema;
  },
  /**
   * @generated from rpc crm.v1.ContactQueriesService.ListContacts
   */
  listContacts: {
    methodKind: "unary";
    input: typeof ListContactsRequestSchema;
    output: typeof ListContactsResponseSchema;
  },
  /**
   * @generated from rpc crm.v1.ContactQueriesService.GetContactsByCustomAttribute
   */
  getContactsByCustomAttribute: {
    methodKind: "unary";
    input: typeof GetContactsByCustomAttributeRequestSchema;
    output: typeof GetContactsByCustomAttributeResponseSchema;
  },
  /**
   * @generated from rpc crm.v1.ContactQueriesService.CheckSearchPermissions
   */
  checkSearchPermissions: {
    methodKind: "unary";
    input: typeof CheckContactSearchPermissionsRequestSchema;
    output: typeof CheckContactSearchPermissionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_crm_v1_contact, 0);

/**
 * @generated from service crm.v1.ContactCommandsService
 */
export const ContactCommandsService: GenService<{
  /**
   * @generated from rpc crm.v1.ContactCommandsService.CreateContact
   */
  createContact: {
    methodKind: "unary";
    input: typeof CreateContactRequestSchema;
    output: typeof CreateContactResponseSchema;
  },
  /**
   * @generated from rpc crm.v1.ContactCommandsService.UpdateContact
   */
  updateContact: {
    methodKind: "unary";
    input: typeof UpdateContactRequestSchema;
    output: typeof UpdateContactResponseSchema;
  },
  /**
   * @generated from rpc crm.v1.ContactCommandsService.DeleteContact
   */
  deleteContact: {
    methodKind: "unary";
    input: typeof DeleteContactRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_crm_v1_contact, 1);

